import { SaasPortalService } from "@ascend/ui-core/services";
import { useEffect, useState } from "react";

export const useSaasPortalService = () => {
  const [saasPortalService, setSaasPortalService] =
    useState<SaasPortalService>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    const initialiseSaasPortalService = () => {
      const serviceInstance = new SaasPortalService(
        process.env["SAAS_PORTAL_SVC_URL"]!,
      );
      // if running locally, authenticate with the local credentials prior to setting the service
      if (process.env["PRODUCT_ENVIRONMENT"] === "development") {
        if (!process.env["LOCAL_USERNAME"] || !process.env["LOCAL_PASSWORD"]) {
          setError(
            "Error initialising application: local credentials not available",
          );
          return;
        }
        serviceInstance
          .createTokenFromCredentials(
            process.env["LOCAL_USERNAME"],
            process.env["LOCAL_PASSWORD"],
          )
          .then(authResponse => {
            console.debug(
              "Development authentication intialised from response",
              authResponse,
            );
            setSaasPortalService(serviceInstance);
          })
          .catch(() =>
            setError(
              "Error initialising application: authentication using local credentials failed",
            ),
          );
      } else {
        setSaasPortalService(serviceInstance);
      }
    };
    initialiseSaasPortalService();
  }, []);

  return { saasPortalService, error };
};
